import React from "react"
import { withStyles, WithStyles, createStyles } from "@material-ui/core"
import { CSSProperties } from "@material-ui/core/styles/withStyles"

import Screenshot from "./Phone"

const styles = () => {
  const sideStyles: CSSProperties = {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    width: "13rem",
    opacity: 0.15,
  }

  const offset = `calc(100% - 3rem)`

  return createStyles({
    root: {
      position: "relative",
      overflowX: "hidden",
      display: "flex",
      justifyContent: "center",
    },
    left: {
      ...sideStyles,
      right: offset,
    },
    right: {
      ...sideStyles,
      left: offset,
    },
    middle: {
      width: "14.625rem",
    },
  })
}

interface Props extends WithStyles<typeof styles> {}

const TriplePhones = ({ classes }: Props) => {
  return (
    <div className={classes.root}>
      <Screenshot classes={{ root: classes.left }} direction="left" />
      <Screenshot classes={{ root: classes.middle }} direction="middle" />
      <Screenshot classes={{ root: classes.right }} direction="right" />
    </div>
  )
}

export default withStyles(styles)(TriplePhones)
